module.exports = __webpack_public_path__ + "img/07_Anan.98044be0.jpg";